import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

export const LeaseStatusTag = ({
  status,
}: {
  status: APITypes.LeaseStatusType;
}) => {
  const { t } = useTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("Created");

  switch (status) {
    case APITypes.LeaseStatusType.Active: {
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Active");
      break;
    }
    case APITypes.LeaseStatusType.Terminating: {
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Terminating");
      break;
    }
    case APITypes.LeaseStatusType.Expired: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Expired");
      break;
    }
    case APITypes.LeaseStatusType.Terminated: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Cancelled");
      break;
    }
    case APITypes.LeaseStatusType.Rejected: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Rejected");
      break;
    }
    case APITypes.LeaseStatusType.UnderReview: {
      color = "yellow";
      icon = <SyncOutlined />;
      statusText = "Under Review";
      break;
    }
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
